import React from "react";
import './CheckBox.css';
import { forwardRef } from 'react';

const CheckBox =  forwardRef(({name, onChange, checked, classNameMainContainer}, ref) => {
    classNameMainContainer = classNameMainContainer ?? "checkbox_margin"
    
    return(
        <div className={"checkbox " +classNameMainContainer}>
            <input className="checkbox-input" type="checkbox" id={name} name={name} ref={ref} onChange={onChange} defaultChecked= {checked}></input>
            <label className="checkbox-background" htmlFor={name}>
                <label className="circle" htmlFor={name}></label>
            </label>
        </div>
    )
});

CheckBox.defaultProps = { name : ''}

export default CheckBox;